import React from 'react';
import { siteService } from "../../services/api";

export default function AdminSiteConfigTab({ site, setSite, actionLoading, setActionLoading, setError }) {
    
    // Manejador para inputs de texto y colores
    const handleInputChange = (e, section, field) => {
        const value = e.target.value;
        setSite({
            ...site,
            site: {
                ...site.site,
                [section]: section === 'colors' 
                    ? { ...site.site.colors, [field]: value }
                    : value
            }
        });
    };

    const handleFileChange = async (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        setActionLoading(true);
        try {
            const { data } = await siteService.uploadImage(file);
            const updatedSite = { ...site.site };
            
            if (type === 'banner') {
                updatedSite.bannerUrl = data.url;
            } else {
                updatedSite.carouselImages = [...(updatedSite.carouselImages || []), { url: data.url }];
            }
            
            const newData = { ...site, site: updatedSite };
            setSite(newData);
            // Auto-guardado de la URL para evitar pérdida de datos si no dan a "Guardar Todo"
            await siteService.updateSite(newData);
        } catch (err) {
            setError("Error al subir imagen");
        } finally {
            setActionLoading(false);
        }
    };

    const saveChanges = async () => {
        setActionLoading(true);
        try {
            await siteService.updateSite(site);
            alert("¡Configuración guardada con éxito!");
        } catch (err) {
            setError("Error al guardar la configuración");
        } finally {
            setActionLoading(false);
        }
    };

    const config = site?.site;

    return (
        <div className="space-y-6 pb-10">
            {/* INFORMACIÓN GENERAL */}
            <div className="p-6 border rounded-xl bg-white shadow-sm space-y-4">
                <h3 className="text-lg font-bold text-gray-800 border-b pb-2">Información General</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Nombre del Partido</label>
                        <input 
                            type="text" 
                            value={config?.party || ''} 
                            onChange={(e) => handleInputChange(e, 'party')}
                            className="mt-1 block w-full border rounded-md p-2 bg-gray-50 focus:ring-primary focus:border-primary"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Ubicación / Ciudad</label>
                        <input 
                            type="text" 
                            value={config?.location || ''} 
                            onChange={(e) => handleInputChange(e, 'location')}
                            className="mt-1 block w-full border rounded-md p-2 bg-gray-50"
                        />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Slogan de Campaña</label>
                    <textarea 
                        rows="2"
                        value={config?.slogan || ''} 
                        onChange={(e) => handleInputChange(e, 'slogan')}
                        className="mt-1 block w-full border rounded-md p-2 bg-gray-50"
                    />
                </div>
            </div>

            {/* IDENTIDAD VISUAL (COLORES) */}
            <div className="p-6 border rounded-xl bg-white shadow-sm">
                <h3 className="text-lg font-bold text-gray-800 border-b pb-2 mb-4">Identidad Visual</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {['primary', 'dark', 'white', 'black'].map((colorField) => (
                        <div key={colorField}>
                            <label className="block text-xs font-semibold uppercase text-gray-500 mb-1">{colorField}</label>
                            <div className="flex items-center gap-2">
                                <input 
                                    type="color" 
                                    value={config?.colors?.[colorField] || '#000000'} 
                                    onChange={(e) => handleInputChange(e, 'colors', colorField)}
                                    className="h-10 w-10 border-none cursor-pointer"
                                />
                                <span className="text-sm font-mono">{config?.colors?.[colorField]}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* RECURSOS MULTIMEDIA (Banner y Carousel) */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="p-6 border rounded-xl bg-white shadow-sm">
                    <h3 className="font-bold mb-4">Banner Hero</h3>
                    <input type="file" onChange={(e) => handleFileChange(e, 'banner')} className="text-sm w-full" />
                    {config?.bannerSignedUrl && (
                        <img src={config.bannerSignedUrl} className="mt-4 h-32 w-full object-cover rounded-lg border shadow-inner" />
                    )}
                </div>

                <div className="p-6 border rounded-xl bg-white shadow-sm">
                    <h3 className="font-bold mb-4">Fotos Carousel</h3>
                    <input type="file" onChange={(e) => handleFileChange(e, 'carousel')} className="text-sm mb-4 w-full" />
                    <div className="grid grid-cols-3 gap-2 max-h-40 overflow-y-auto p-1">
                        {config?.carouselImages?.map((img, i) => (
                            <div key={i} className="relative group aspect-video border rounded overflow-hidden bg-gray-100">
                                <img src={img.signedUrl} className="w-full h-full object-cover" />
                                <button 
                                    onClick={() => {
                                        const filtered = config.carouselImages.filter((_, idx) => idx !== i);
                                        setSite({ ...site, site: { ...config, carouselImages: filtered } });
                                    }}
                                    className="absolute top-0 right-0 bg-red-600 text-white p-1 rounded-bl-lg opacity-0 group-hover:opacity-100 transition-opacity"
                                >✕</button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ACCIÓN PRINCIPAL */}
            <div className="sticky bottom-0 bg-gray-50 p-4 border-t flex justify-end">
                <button 
                    onClick={saveChanges}
                    disabled={actionLoading}
                    className="px-10 py-3 bg-[color:var(--primary)] text-white font-black rounded-full shadow-xl hover:brightness-110 transition-all disabled:opacity-50"
                    style={{ backgroundColor: config?.colors?.primary }}
                >
                    {actionLoading ? "GUARDANDO..." : "GUARDAR CONFIGURACIÓN"}
                </button>
            </div>
        </div>
    );
}